import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { FC, useState } from "react";

interface Props {
  target: User | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DeleteUserDialog: FC<Props> = ({ target, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    setLoading(true);
    onConfirm().finally(() => setLoading(false));
  };

  return (
    <Dialog open={!!target} onClose={onClose}>
      <DialogTitle>Supprimer l&apos;utilisateur</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Êtes-vous sûr de vouloir supprimer <strong>{target?.username}</strong> ? Cette action est irréversible.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button color="error" variant="contained" onClick={handleConfirm} disabled={loading}>
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserDialog;
